import { Position } from "@xyflow/react";
import { Send } from "lucide-react";
import { BaseHandle } from "../../components/base-handle";
import { BaseNode, BaseNodeContent } from "../../components/base-node";
import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";
import { useTranslation } from "react-i18next";

export const KLAVIYO_ACTION_NODE_WIDTH = 250;
export const KLAVIYO_ACTION_NODE_HEIGHT_ESTIMATION = 120;

export function KlaviyoActionNodeEditor({ id }: { id: string }) {
  const { t } = useTranslation("trackoffice");

  return (
    <ContextualTipsTrigger
      tips={[
        {
          id: "workflow-node-klaviyo",
          Icon: Send,
          title: t(
            "workflowsEditor.tips.workflowNodeKlaviyo.title",
            "This is a Klaviyo event action node",
          ),
          description: t(
            "workflowsEditor.tips.workflowNodeKlaviyo.desc",
            "This node will send a custom event to Klaviyo to trigger flows (e.g. post-purchase emails).",
          ),
        },
      ]}
    >
      <BaseNode nodeId={id} style={{ position: "relative" }}>
        <BaseNodeContent>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">
                {t("workflowsEditor.klaviyoNode.action", "Action")}
              </span>
              <span className="text-xs mt-1 font-semibold">
                {t(
                  "workflowsEditor.klaviyoNode.sendEvent",
                  "Send Klaviyo Event",
                )}
              </span>
            </div>
          </div>
          <BaseHandle type="target" position={Position.Left} />
          <BaseHandle
            type="source"
            position={Position.Right}
            style={{ top: "50%", transform: "translateY(-50%)" }}
          />
        </BaseNodeContent>
      </BaseNode>
    </ContextualTipsTrigger>
  );
}
